import React, { useState, useEffect, Suspense } from 'react'
import { Image, Container, Row, Col } from "react-bootstrap";
import Navbar from "./Navbar";
import "../css/Header.css";
import { imagePath } from '../Utils/WHL/helpers';
import UserWayAccessibilityMenu from "./UserWayAccessibilityMenu/index";

const Header = () => {
    const [logoImage, setLogoImage] = useState('')
    const [isMobile, setisMobile] = useState(window.innerWidth < 575)

    const handleScreenResize = () => {
        window.innerWidth > 575 ? setisMobile(false) : setisMobile(true)
    }
    useEffect(() => {

        if (window.innerWidth > 575) {
            setLogoImage('SunWest-Logo.png')
        }
        else {
            setLogoImage('Sun West_White.png')
        }

        window.addEventListener('resize', handleScreenResize);
        return () => {
            window.removeEventListener('resize', handleScreenResize);
        }
    }, [])

    useEffect(() => {
        isMobile ? setLogoImage('Sun West_White.png') : setLogoImage('SunWest-Logo.png')
    }, [isMobile])

    return (

        <Container fluid className="logo-only-header px-0 fixed-top">
            <Container>
                <Row className="m-0">
                    <Col lg={3} md={3} className="p-0 pl-2 swmc-logo-parent">
                        <div className="d-flex">
                        <a href={process.env.REACT_APP_SWMC_MAIN_SITE} target="_blank">
                            <Image
                                className="swmc-logo"
                                width="600"
                                height="117"
                                src={`${imagePath}/${logoImage}`}
                                fluid
                                alt="Sun West Mortgage Company, Inc. logo"
                                srcSet={`${imagePath}/${logoImage} 1650w, ${imagePath}/${logoImage} 300w, ${imagePath}/${logoImage} 768w,`}
                                sizes="(max-width:1650px) 100vw, 1650px"
                            />
                        </a>
                        {/* <UserWayAccessibilityMenu
                  color="white"
                  width={40}
                  height={40}
                /> */}
                        </div>
                    </Col>
                    <Col className="text-align-right pr-0">
                        {/* Navbar placed inside header for sticky responsive behavior */}
                        <Navbar isMobile={isMobile} />
                    </Col>
                </Row>
            </Container>
        </Container>
    );
}

export default Header;